import React from 'react';

import { $DialCodePreview } from './DialCodePreview.styles';

export interface DialCodePreviewStyleProps {
  style?: React.CSSProperties;
  className?: string;
}

export interface DialCodePreviewProps extends DialCodePreviewStyleProps {
  dialCode: string;
  prefix: string;
  disabled?: boolean;
}

export const DialCodePreview: React.FC<DialCodePreviewProps> = ({
  dialCode,
  prefix,
  disabled,
  style,
  className,
}) => {
  return (
    <$DialCodePreview $disabled={disabled} className={className} style={style}>
      {`${prefix}${dialCode}`}
    </$DialCodePreview>
  );
};
